export default abstract class Model {
	abstract exportToJson(): any;
}